export const whitelist = [
  'starredParcels',
  'accordiansOpen',
  'customLayers',
  'reportResponses',
  'termsAccepted',
];
